import React from "react";
import RoomType from "../../components/RoomType";

const Roomtype = () => <RoomType />;

export default Roomtype;
